export const isRouteEyeAdmin = () =>{
    const userState = localStorage.getItem("userState");
    if(!userState) return false;
    try{
        const user = JSON.parse(userState).user;
        return (
            user.organizationId === 5 && user.email === "sales@routeeye.io"
        )
    }catch {
        return false
    }
}